'use client';

import { usePageAction } from '@repo/platform-analytics/hooks/usePageAction';
import { getOrCreateId } from '@repo/platform-utils/static-ids';
import { useRef } from 'react';
import type { BranchId } from '@/shared/config/funnel/constants';
import { ANALYTICS_ACTION_NAME, ANALYTICS_EXIT_INTENT_ACTION_SECTION } from './constants';
export function useExitModalCloseAction(branchId: BranchId | null) {
  const activityIdRef = useRef('');
  const featureViewedActivityId = getOrCreateId(activityIdRef);
  const fireCloseAction = usePageAction({
    actionName: ANALYTICS_ACTION_NAME,
    actionSection: ANALYTICS_EXIT_INTENT_ACTION_SECTION,
    actionType: 'close',
    actionInput: 'exit',
    parentActivityId: featureViewedActivityId,
    pageBranchName: branchId
  });
  return {
    featureViewedActivityId,
    fireCloseAction
  };
}